import { GALLERY_PATH } from '@constants';

export const setTagUrl = ({ tag, type, queryTags, locale }) => {
  const queryStyle = queryTags.style ? queryTags.style.toLowerCase() : '';
  const queryRoom = queryTags.room ? queryTags.room.toLowerCase() : '';
  const main = {
    style: queryStyle,
    room: queryRoom,
  };
  let url = `/${locale}/${GALLERY_PATH}/`;
  let propsStyle = queryTags.st ? [...queryTags.st] : [];
  let propsRoom = queryTags.rm ? [...queryTags.rm] : [];

  tag.address = tag.address ? tag.address.toLowerCase() : '';

  if (tag.active) {
    if (type === 'style') {
      if (main.style === tag.address) {
        if (propsStyle.length) {
          main.style = propsStyle[0];
          propsStyle.shift();
        } else {
          main.style = '';
        }
      } else {
        const index = propsStyle.indexOf(tag.address);

        if (index !== -1) {
          propsStyle.splice(index, 1);
        }
      }
    } else if (type === 'room') {
      if (main.room === tag.address) {
        if (propsRoom.length) {
          main.room = propsRoom[0];
          propsRoom.shift();
        } else {
          main.room = '';
        }
      } else {
        const index = propsRoom.indexOf(tag.address);

        if (index !== -1) {
          propsRoom.splice(index, 1);
        }
      }
    }
  } else {
    if (type === 'style') {
      if (queryStyle) {
        propsStyle.push(tag.address);
      } else {
        main.style = tag.address;
      }
    } else if (type === 'room') {
      if (queryRoom) {
        propsRoom.push(tag.address);
      } else {
        main.room = tag.address.toLowerCase();
      }
    }
  }

  if (main.style && main.room) {
    url += `${main.room}/${main.style}/`;
  } else if (main.style || main.room) {
    url += `${main.room || main.style}/`;
  }

  url += propsStyle.length ? `?st=${propsStyle.join(',')}` : '';
  url += propsRoom.length ? (propsStyle.length ? `&rm=${propsRoom.join(',')}` : `?rm=${propsRoom.join(',')}`) : '';

  return url;
};

// Вывод урла для СЕО
export const setTagSeoUrl = ({ tag, type, queryTags, locale }) => {
  const queryStyle = queryTags.style ? queryTags.style.toLowerCase() : '';
  const queryRoom = queryTags.room ? queryTags.room.toLowerCase() : '';
  const main = {
    style: queryStyle,
    room: queryRoom,
  };
  let url = `/${locale}/${GALLERY_PATH}/`;

  tag.address = tag.address ? tag.address.toLowerCase() : '';

  if (type === 'style') {
    main.style = tag.address;
  } else if (type === 'room') {
    main.room = tag.address.toLowerCase();
  }

  if (main.style && main.room) {
    url += `${main.room}/${main.style}/`;
  } else if (main.style || main.room) {
    url += `${main.room || main.style}/`;
  }

  return url;
};

export const addPropsTags = ({ type, tags, queryTags, locale }) => {
  const list = (type === 'style' ? tags.style : tags.room) || [];
  const mainQuery = (type === 'style' ? queryTags.style : queryTags.room) || [];
  const getQuery = (type === 'style' ? queryTags.st : queryTags.rm) || [];

  return list.map((tag) => {
    tag.address = tag.address ? tag.address.toLowerCase() : '';
    tag.active = mainQuery === tag.address || getQuery.indexOf(tag.address) !== -1;
    tag.link = setTagUrl({ tag, type, queryTags, locale });
    tag.href = setTagSeoUrl({ tag, type, queryTags, locale });

    return tag;
  });
};

export const filteredByTags = ({ projects, queryTags }) => {
  const tagStyle = queryTags.st ? [...queryTags.st] : [];
  const tagRoom = queryTags.rm ? [...queryTags.rm] : [];

  if (queryTags.style) {
    tagStyle.push(queryTags.style);
  }

  if (queryTags.room) {
    tagRoom.push(queryTags.room);
  }

  if (Object.keys(queryTags).length === 0) {
    return projects;
  }

  return projects.filter((project) => {
    let passS = false;
    let passR = false;

    if (tagStyle.length) {
      for (let i = 0; i <= tagStyle.length - 1; i++) {
        if ((project['tags_style'] || []).map((tag) => tag.address.toLowerCase()).indexOf(tagStyle[i]) !== -1) {
          passS = true;
        }
      }
    } else {
      passS = true;
    }

    if (tagRoom.length) {
      for (let i = 0; i <= tagRoom.length - 1; i++) {
        if ((project['tags_room'] || []).map((tag) => tag.address.toLowerCase()).indexOf(tagRoom[i]) !== -1) {
          passR = true;
        }
      }
    } else {
      passR = true;
    }

    return passS && passR;
  });
};

export const addTagsInProject = ({ project, tags }) => {
  const style = (project['tags_style'] || []).map((alias) => tags.style.find((tag) => tag.alias === alias));
  const room = (project['tags_room'] || []).map((alias) => tags.room.find((tag) => tag.alias === alias));

  return {
    ...project,
    tags_style: style.filter((item) => Boolean(item)),
    tags_room: room.filter((item) => Boolean(item)),
  };
};

export const addTagsInProjects = ({ projects, tags }) => {
  return projects.map((project) => {
    return addTagsInProject({ project, tags });
  });
};

export const slicePagination = ({ projects, currentPage, pageCountPage }) => {
  const start = (currentPage - 1) * pageCountPage;
  const end = start + pageCountPage;

  return projects.slice(start, end);
};

export const findDescriptionTag = ({ queryTags, tags }) => {
  const queryTagsStyle = queryTags.style ? queryTags.style.toLowerCase() : '';
  const queryTagsRoom = queryTags.room ? queryTags.room.toLowerCase() : '';

  if (queryTagsStyle && queryTagsRoom) {
    return tags.combo
      ? tags.combo.find((tag) => tag.address.toLowerCase() === `${queryTagsRoom}_${queryTagsStyle}`)
      : null;
  } else if (queryTagsStyle) {
    return tags.style ? tags.style.find((tag) => tag.address.toLowerCase() === queryTagsStyle) : null;
  } else if (queryTagsRoom) {
    return tags.room ? tags.room.find((tag) => tag.address.toLowerCase() === queryTagsRoom) : null;
  }

  return null;
};

export const getSimilarProjects = ({ projects, project }) => {
  const total = [...projects.filter((pr) => pr.id !== project.id)];
  const remains = [];
  const similar = total.filter((item) => {
    const tagsMode = ['tags_style', 'tags_room'];

    for (let y = 0; y < tagsMode.length; y++) {
      const length = item[tagsMode[y]] ? item[tagsMode[y]].length : 0;

      for (let i = 0; i < length; i++) {
        if ((project[tagsMode[y]] || []).indexOf(item[tagsMode[y]][i]) !== -1) {
          return item;
        }
      }
    }

    remains.push(item);

    return false;
  });

  return [...similar, ...remains].slice(0, 4);
};

export const getQueryParams = (query) => {
  const params = {};

  if (query.style && query.room) {
    params.tag = query.room;
    params.style = query.style;
  } else if (query.style || query.room) {
    params.tag = query.style || query.room;
  }

  if (query.st && query.st.length) {
    params.st = query.st.join(',');
  }

  if (query.rm && query.rm.length) {
    params.rm = query.rm.join(',');
  }

  return params;
};
